export const truncate = (input: string, limit: number) => {
  if (input && input.length > limit) {
    return input.substring(0, limit) + "...";
  }
  return input;
};
